import React from "react"
import { Redirect } from "react-router-dom"
import { useMountEffect } from "@utils/useMountEffect"
import { useAuth } from "@services/useAuth"

const Logout = () => {
  const { logout } = useAuth()

  useMountEffect(() => {
    logout()
  })

  console.log("[Logout]", "Signing out")

  return <Redirect to="/login" />
}

export default Logout
